// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2cAFk","title":"Header_title__23Uu0","left":"Header_left__z5XM1","clinicName":"Header_clinicName__3utFI"};